import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_lista_compras, customAuth} from '@/FirebaseConfig'
import {secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        lista_de_compras_existencias:[],
        dialog: false,
        record_por_usuario:[],
        record_por_estado:[],
      },
      actions: {
        obtener_por_estado:({state}, {aprobado})=>{
          state.record_por_estado = []
          let ref = coleccion_lista_compras.where('estado_de_proceso', '==', 'esperando')
          if(!aprobado) ref = ref.where('aprobado', '==', true)
          ref.onSnapshot(data=>{
            const registro = []
            data.docs.map( item => {
              registro.push({...item.data(), id_requerimiento: item.id, creado_el:  secondsToFullTimestamp(item.data().creado_el)})
            } )
            state.record_por_estado = registro
          } )
        },
        obtener_por_usuario: ({state})=>{
          if(!customAuth.currentUser) return 
          coleccion_lista_compras.where('estado_de_proceso', '==', 'esperando')
          .where('creado_por', '==',  customAuth.currentUser.displayName)
          .onSnapshot(data=>{
            const registro = []
            data.docs.map( item => {
              registro.push({...item.data(), id_requerimiento: item.id, creado_el:  secondsToFullTimestamp(item.data().creado_el)})
            } )
            state.record_por_usuario = registro
          } )
        },
        add:context=>{
          context.state.lista_de_compras_existencias.map(item=>{
            coleccion_lista_compras.add({...item,  creado_el: new Date, creado_por: customAuth.currentUser.displayName,estado_de_proceso:'esperando'})
          })
          context.commit('Helpers/launchSnackbar', 'Se ha registrado correctamente', { root: true })
          context.state.dialog = false
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.lista_de_compras_existencias=[]
          context.state.lista_de_compras_cotizaciones=[]
        },
        borrar_requerimiento_por_id:(context, id_requerimiento)=> new Promise( async( resolve, rejected)=>{
          try {
            await coleccion_lista_compras.doc(id_requerimiento).update({estado_de_proceso:'procesado'})
            resolve(true)
          } catch (error) {
            rejected(error)
          }
        }),
        aprobar_item: async ({commit}, {id, aprobado})=> {
          try{
            commit('Helpers/launchSnackbar', 'Aprobando item, un momento...', { root: true })
            await coleccion_lista_compras.doc(id).update({aprobado: !aprobado, aprobado_por: customAuth.currentUser.displayName})
            commit('Helpers/launchSnackbar', 'Se ha aprobado el item para cotizar', { root: true })
          } catch (error){
            console.log(error)
            commit('Helpers/launchSnackbar', 'Ha ocurrido un error', { root: true })
          }
        }
      },
     
  }
  